<template>
    <div>
        <van-nav-bar
          title="订单支付"
          left-arrow
          @click-left="onClickLeft"
        />
        <div class="main">
            <img src="../../assets/shop/pay_success.png" alt="">
            <div class="words">支付成功</div>
            <van-button round class="look" @click="gotoOrderDetail">查看订单</van-button>
            <van-button round class="back" @click="closePage">返回首页</van-button>
        </div>
    </div>
</template>

<script>
import api from '../Api'
export default {
    mixins: [api],
    data() {
        return {
            
        }
    },
    computed: {
        order_num() {
            return this.$route.query.order_num
        }
    },
    methods: {
        gotoOrderDetail() {
            this.$router.push({
                name: 'order.detail',
                query: {
                    order_num: this.order_num
                }
            })
        }
    },
}
</script>

<style lang="less" scoped>
    .main {
        margin-top: 2.5rem;
        padding: 1.95rem 1.35rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        img {
            width: 2.95rem;
            height: 3.1rem;
            margin-bottom: .6rem;
        }
        .words {
            text-align: center;
            font-weight: 700;
            color: #670000;
            font-size: .8rem;
            margin-bottom: 2.6rem;
        }
        .van-button {
            width: 100%;
            height: 2.5rem;
            margin-bottom: .9rem;
            font-size: .8rem;
            &.look {
                background-color: #000;
                color: #fff;
            }
            &.back {
                background-color: #e4e4e4;
                color: #656565;
            }
        }
    }
</style>